import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  CatDocStatusEnum,
  CatDoc,
  Catalog,
  CatPhraseSubType,
  IndPhrase,
  IndPhraseSearchParams,
  CatPhraseStatusEnum,
  BoundingBox,
  IndImage,
  IndElement,
  Card,
  CardSearchParams,
  CatDocStateTagEnum,
  ExtRef,
  DirectLinkCatalogDoc,
  CatalogStatusEnum,
} from '../shared/models/cat.model';
import { DocViewerComponent } from '../shared/components/doc-viewer/doc-viewer.component';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState, actionsList } from '../shared/redux/store';
import { CatService } from '../shared/services/cat.service';
import { IntegrationService } from '../shared/services/integration.service';
import {
  ActivatedRoute,
  Params,
  PRIMARY_OUTLET,
  Router,
} from '@angular/router';
import { SharedService } from '../shared/services/shared.service';
import Chart from 'chart.js';
import { keyCodes } from '../shared/models/key-codes.model';
import { TreeNode } from 'primeng/api';
import {
  AnnotationElement,
  DataElement,
  ProcessRunStatusEnum,
  newCatSystemVersion
} from '../shared/models/common';
import { Unsubscribe } from 'redux';
import { AuthService } from '../shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { PdfViewerComponent } from '../shared/components/pdf-viewer/pdf-viewer.component';
import { CatDocPhraseListComponent } from './cat-doc-phrase-list/cat-doc-phrase-list.component';
import { forkJoin, Subject, Subscribable, Subscription } from 'rxjs';
import { CatPhraseBulkEditComponent } from './cat-phrase-bulk-edit/cat-phrase-bulk-edit.component';
import { Location } from '@angular/common';
import { TabIdList } from '../shared/models/tab.model';
import { CatDocCardsComponent } from './cat-doc-cards/cat-doc-cards.component';
import { takeUntil } from 'rxjs/operators';
import { hide } from '@popperjs/core';
import { ReevalJobService } from '@shared/services/reeval-job.service';
import { DocumentPositionSyncService } from '@shared/services/document-position-sync.service';
import { getObjectPropValue } from '@shared/utils';

@Component({
    selector: 'cat-doc',
    templateUrl: './cat-doc.component.html',
    styleUrls: ['./cat-doc.component.scss'],
    standalone: false
})
export class CatDocComponent implements OnInit {
  @Input() stateTag: CatDocStateTagEnum = CatDocStateTagEnum.PRIME;
  @Input() srcPhraseId: number;
  @Input() extCatVersionId: number;

  @Output() onAddExtRef = new EventEmitter();
  @Output() onGoBack = new EventEmitter();

  @ViewChild('docViewer') docViewer: PdfViewerComponent;
  @ViewChild('phraseList') phraseList: CatDocPhraseListComponent;
  @ViewChild('phraseBulkEdit') phraseBulkEditCmp: CatPhraseBulkEditComponent;
  @ViewChild('catDocCards') catDocCardsCmp: CatDocCardsComponent;

  loading: boolean;
  filterPhrase: string;
  selectedTypeNodes: TreeNode[];
  filterSubTypes: string[];
  filterMatchStatus: DataElement;
  filterPhraseStatus: DataElement;
  filterContentType: DataElement;
  filterMatchType: DataElement;
  canvasStatus: any;
  ctxStatus: any;
  phraseDetailsOpenSw: boolean;
  un: Unsubscribe;
  initAnnotationsloadedPageNum: number;
  docFrameLoadedPageNum: number;
  phraseListLoadedPageNum: number;
  toggleAllSw: boolean;
  toggleAllImgSw: boolean;
  boundingBoxOpenSw: boolean;
  curBoundingBox: BoundingBox;
  annotateHtmlDirtySw: boolean;
  processStatusTimer: NodeJS.Timeout;
  getProcessStatusIntervalSeconds: number = 3;
  editPhraseTypeOpenSw: boolean;
  panelResizing: boolean;
  toggleImageAnnotationsSw: boolean;
  docCardsOpenSw: boolean;
  addExtRefLoading: boolean;
  tabIdList: TabIdList;
  docFrameLoaded: boolean = false;
  editPhraseOrderOpenSw: boolean;
  docSpellcheckWhitelistingOpenSw: boolean;
  downloadingZip: boolean;
  sub: Subscription;
  activeFilters: boolean = false;

  loadingMoreItems: boolean = false;
  private lastScrollFocusedElementId?: number;
  private scrollSyncFrameId: number | null = null;

  destroy$ = new Subject();

  mode: 'lc_ac' | 'lc_bc' | null = null;

  getProcStatusFailedCnt: number = 0;
  displayProcessStatus: boolean;
  docProcessingTimer: NodeJS.Timeout;
  handleProcessingDocTimer: NodeJS.Timeout;
  docInitInProgress: boolean;
  catId: number;
  catVersionId: number;

  get dlCatDoc(): DirectLinkCatalogDoc {
      return this.ngRedux.getState().dlCatDoc;
    }

  get extSw(): boolean {
    return this.stateTag == CatDocStateTagEnum.PRIME && this.curCat.extSw;
  }

  get showMatchSw(): boolean {
    return !this.extSw && this.stateTag != CatDocStateTagEnum.SEC;
  }

  get lcSw(): boolean {
    if (!this.mode) return false;
    return this.mode.startsWith('lc');
  }

  get doc(): CatDoc {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDoc
      : this.ngRedux.getState().curCatDocStateSec.curCatDoc;
  }

  get curCat(): Catalog {
    return this.ngRedux.getState().curCat;
  }

  get matchSimilarityCodes(): DataElement[] {
    return this.ngRedux.getState().catMatchSimilarityCodes;
  }

  get catPhraseStatusList(): DataElement[] {
    return this.ngRedux.getState().catPhraseStatusList;
  }

  get contentTypeList(): DataElement[] {
    return this.ngRedux.getState().contentTypeList;
  }

  get matchTypeList(): DataElement[] {
    return this.ngRedux.getState().indRuleSimilarityEventList;
  }

  get catPhraseTypes(): TreeNode[] {
    if (!this.ngRedux.getState().catPhraseTypeModel) return [];
    return this.ngRedux.getState().catPhraseTypeModel.treeTypes;
  }

  get displayedPhrases(): IndPhrase[] {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.indDocPhrases
      : this.ngRedux.getState().curCatDocStateSec.indDocPhrases;
  }

  get displayedImages(): IndImage[] {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.indDocImages
      : this.ngRedux.getState().curCatDocStateSec.indDocImages;
  }

  get catDocBoundingBoxes(): BoundingBox[] {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.catDocBoundingBoxes
      : this.ngRedux.getState().curCatDocStateSec.catDocBoundingBoxes;
  }

  get allowAddToCatalog(): boolean {
    return this.doc.statusCode == CatDocStatusEnum.DRAFT;
  }

  get addToCatalogDisabled(): boolean {
    return (
      this.allowAddToCatalog &&
      this.curCat?.claimsManagementType != null &&
      this.curCat.claimsManagementType != 1 &&
      this.curCat.systemVersion > 1
    );
  }

  get allowDetach(): boolean {
    return this.doc.statusCode == CatDocStatusEnum.ADDED_TO_CATALOG
          && CatalogStatusEnum.PUBLISHED != this.curCat.statusCode;
  }

  get allowReopen(): boolean {
    return (
      this.doc.statusCode == CatDocStatusEnum.DETACHED ||
      this.doc.statusCode == CatDocStatusEnum.INACTIVE
    );
  }

  get allowInactivate(): boolean {
    return (
      this.doc.statusCode == CatDocStatusEnum.DETACHED ||
      this.doc.statusCode == CatDocStatusEnum.DRAFT
    );
  }

  get curPage(): number {
    return (this.dlCatDoc && !this.dlCatDoc.dlDocHandled)
    ? this.dlCatDoc.page : (this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDocPageNum
      : this.ngRedux.getState().curCatDocStateSec.curCatDocPageNum);
  }

  get docCards(): Card[] {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.catDocCards
      : this.ngRedux.getState().curCatDocStateSec.catDocCards;
  }

  get enableAddPhrase(): boolean {
    if (
      this.stateTag == CatDocStateTagEnum.PRIME &&
      this.ngRedux.getState().curCatDocStatePrime.indDocPhrases.length == 0
    )
      return false;
    else return true;
  }

  get displayClearFilter(): boolean {
    return (
      this.filterPhrase != null ||
      this.filterSubTypes != null ||
      this.filterMatchStatus != null ||
      this.filterPhraseStatus != null ||
      this.filterContentType != null ||
      this.filterMatchType != null
    );
  }

  get selectedPhrases(): IndPhrase[] {

    let selectedPhrases: IndPhrase[] = [];
    let allPhrases = this.displayedPhrases;

    allPhrases?.forEach((phrase) => {

      if (phrase.checkedSw) {
        selectedPhrases.push(phrase);
      }

      let contentChildren = phrase.contentChildren;
      contentChildren?.forEach((child) => {

        if (child instanceof IndPhrase && child.checkedSw) {

          selectedPhrases.push(child);
        }
      }
      )

      let children = phrase.children;
      children && Object.keys(children).forEach((key) => {

        children[key]?.forEach(child => {
          if (child instanceof IndPhrase && child.checkedSw) {
            selectedPhrases.push(child);
          }
        }
        )
      });
    }
    );
    return selectedPhrases;
  }

  get selectedElements(): IndElement[] {
/*     let elements: IndElement[] = [
      ...this.displayedPhrases,
      ...this.displayedImages,
    ];
    return elements.filter((r) => r.checkedSw); */
    let selectedElements: IndElement[] = [];
    selectedElements =this.getSelectedElements(this.displayedPhrases);
    selectedElements = selectedElements.concat(this.getSelectedElements(this.displayedImages));
    return selectedElements;
  }

  getSelectedElements(elements: IndElement[]) : IndElement[] {
    
    let selectedElements: IndElement[] = [];
    elements?.forEach((element) => {
      if (element.checkedSw) {
        selectedElements.push(element);
      }
      let selectedChildren: IndElement[] = [];

      let contentChildren: IndElement[] = element.contentChildren;
      selectedChildren = contentChildren?.filter((child) => child.checkedSw);
      selectedElements = selectedElements.concat(selectedChildren);

      let imageChildren: IndElement[] = element.imageChildren;
      selectedChildren = imageChildren?.filter((child) => child.checkedSw);
      selectedElements = selectedElements.concat(selectedChildren);

      let children = element.children;
      children && Object.keys(children).forEach((key) => {
        
        selectedChildren = children[key]?.filter((child) => child.checkedSw);
        selectedElements = selectedElements.concat(selectedChildren);
      })
    })
    return selectedElements;
  }

  get displayToggleBoundingBoxes(): boolean {
    return this.catDocBoundingBoxes.length > 0;
  }
  get addToStore(): boolean {
    return this.ngRedux.getState().addToStore;
  }
  set addToStore(value: boolean) {
    this.ngRedux.getState().addToStore = value;
  }

  get totalIndPhrasesResults(): number {

    return this.ngRedux.getState().totalIndPhrasesResults;

  }
  get docPageLoading() {
    
    return this.ngRedux.getState().docPageLoading;
  }
  get displayCatInfo(): boolean {
    return this.stateTag == CatDocStateTagEnum.PRIME && !this.mode;
  }

  get displayDocActions(): boolean {
    return this.stateTag == CatDocStateTagEnum.PRIME && !this.mode;
  }

  get displayDrawMode(): boolean {
    return this.stateTag == CatDocStateTagEnum.PRIME && this.ngRedux.getState().curCatDocStatePrime?.curCatDoc?.statusCode === 'DRAFT';;
  }

  get editable(): boolean {
    return (
      this.doc.statusCode == CatDocStatusEnum.DRAFT &&
      !this.mode &&
      this.stateTag == CatDocStateTagEnum.PRIME &&
      !this.curCat.extSw &&
      !this.doc.isProcessRunning
    );
  }

  get allowAddExtRef(): boolean {
    return this.stateTag == CatDocStateTagEnum.SEC;
  }

  get viewerHeightOffset(): string {
    if (this.stateTag == CatDocStateTagEnum.PRIME) {
      return 'calc(100vh - 100px)';
    } else {
      return 'calc(100vh - 200px)';
    }
  }

  get pageLoading(): boolean {
    return this.ngRedux.getState().docPageLoading;
  }

  get currLoadedIndPhrasesSearchResultNum() {
      
      return this.ngRedux.getState().currLoadedIndPhrasesSearchResultNum;
  }

  get positionSyncEnabled(): boolean {
    return this.documentPositionSyncService.isEnabled(this.ngRedux.getState().uiConfig);
  }

  get sortImagesInPositionSync(): boolean {
    return getObjectPropValue(
      this.ngRedux.getState().uiConfig,
      'tiles_config.images_sorted_by_y'
    ) === true;
  }

  set currLoadedIndPhrasesSearchResultNum(currLoadedIndPhrasesSearchResult) {
      
      this.ngRedux.getState().currLoadedIndPhrasesSearchResultNum = currLoadedIndPhrasesSearchResult;
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private integrationService: IntegrationService,
    private router: Router,
    private sharedService: SharedService,
    private authService: AuthService,
    private translateService: TranslateService,
    private location: Location,
    private route: ActivatedRoute,
    private reevalJobService: ReevalJobService,
    private documentPositionSyncService: DocumentPositionSyncService
  ) {
    this.tabIdList = this.ngRedux.getState().ui_tabIdList;
    this.un = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.UPD_CAT_DOC_STATS:
          this.drawStatusChart();
          break;
        case actionsList.GET_IND_DOC_PHRASES:
          if (appState._currentActionCatDocStateTag != this.stateTag)
            return;

          {
          const loadedPageNum = this.curPage;
          const pageChanged = this.phraseListLoadedPageNum !== loadedPageNum;
          this.phraseListLoadedPageNum = this.curPage;
          this.lastScrollFocusedElementId = undefined;
          if (pageChanged && this.positionSyncEnabled) {
            requestAnimationFrame(() => {
              this.phraseList?.scrollToFirstElementOnPage(loadedPageNum);
            });
          }
          }
          /*
          if (
            this.initAnnotationsloadedPageNum !== this.curPage &&
            this.docFrameLoadedPageNum == this.curPage
          ) {
            this.addAllAnnotationsToDoc();

            if (this.lcSw) return;
            setTimeout(() => {
              this.togglePendingAnnotations();
            }, 500);
          }
          */
          break;
        case actionsList.ADD_IND_DOC_PHRASES:
          if (appState._currentActionCatDocStateTag != this.stateTag) return;
          this.onPdfScroll();
          break;
        case actionsList.REANNOTATE_CAT_DOC_REQ:
          if (appState._currentActionData == true) {
            //this.createAnnotateHtmlReq();
            this.docViewer.goToPage(this.curPage);
          }
          break;
      }
    });
  }

  ngOnInit(): void {
    this.reevalJobService.setDocViewOpen('CAT', true);
    this.reevalJobService.resumePersistedJobs();

    this.catId  = parseInt(this.route.snapshot.paramMap.get('catId'), 10);
    this.catVersionId  = parseInt(this.route.snapshot.paramMap.get('catVersionId'), 10);

    if (this.catId == null || this.catVersionId == null) {

      this.router.navigate([this.sharedService.routeEnum.URL_CATALOG_LIST]);
      return;
    }
    if (this.curCat == null) {

      this.catService.getCat(this.ngRedux.getState().curEnv.id, this.catId, this.catVersionId).subscribe((cat: Catalog) => {
          this.ngRedux.dispatch({
            type: actionsList.SELECT_CATALOG,
           data: cat
        });
        this.sendRequestForSingleDoc();
      })
    } else {
      this.sendRequestForSingleDoc();
    }


  }

  sendRequestForSingleDoc() {
    const id = this.route.snapshot.paramMap.get('docId');
    if (id) {
      //get rev doc with id

      let docId = parseInt(id, 10);
      let envId = this.ngRedux.getState().curEnv.id;
      let catVersionId = this.curCat.catVersionId;
      this.docInitInProgress = true;
      this.catService.getSingleCatDoc(docId, catVersionId, envId).subscribe((catDoc: CatDoc) => {

        const versionId = this.route.snapshot.queryParams['versionId'];
        if (versionId) {
          
          const versionIdValue = Number.parseInt(versionId, 10);
          catDoc = catDoc.histDocs.find((d) => d.versionId == versionIdValue);
        }
        let viewDoc: CatDoc = null;
        if (catDoc.histDocs.length > 0) {
          viewDoc = catDoc.histDocs.find((d) => d.versionId == catDoc.lastVersionId);
        } else {
          viewDoc = catDoc;
        }

        this.ngRedux.dispatch({
          type: actionsList.SELECT_CAT_DOC,
          data: viewDoc,
          catDocSTateTag: CatDocStateTagEnum.PRIME
        });
        this.docInitInProgress = false;
        this.docInitialization();

      });
    } else {
        // navigate to cat doc list
        this.ngRedux.dispatch({
          type: actionsList.UI__ROUTE_NAVIGATION,
          data: this.sharedService.routeEnum.URL_CATALOG(this.catId, this.catVersionId) ,
        });
        this.router.navigate([this.sharedService.routeEnum.URL_CATALOG(this.catId, this.catVersionId)]);

      }
  }
  docInitialization() {
    if (this.doc?.isProcessRunning) {
      this.docProcessingTimer = setInterval(() => {
        if (!this.doc?.isProcessRunning) {
          //clear cache
          // reload page to get updated doc status
          this.ngRedux.dispatch({
            type: actionsList.INVALIDATE_PDF_CACHE
          });
          this.ngRedux.dispatch({
            type: actionsList.RELOAD_CAT_DOC_PAGE_REQ
          });
          clearInterval(this.docProcessingTimer);
        }
      }, 1000);
    }
    if (this.dlCatDoc) {
      this.dlCatDoc.dlDocHandled = true;
    }
    this.ngRedux.dispatch({
      type: actionsList.GET_TOTAL_FILTER_PHRASES_NUM,
      data: 0
    });
    this.route.params.subscribe((params: Params) => {
      this.mode = params['mode'];
    });

    this.resetFilterParams();
    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
      data: this.dlCatDoc ? this.dlCatDoc.page : 1,
      catDocSTateTag: this.stateTag,
    });
    this.addToStore = false;
    this.getDocCards();
    this.getDocObjects();
    this.catService.changePdfPage$.pipe(takeUntil(this.destroy$)).subscribe((pageNum:number) => {

      this.ngRedux.dispatch({
        type: actionsList.SELECT_CAT_DOC_PAGE_FROM_SEARCH,
        data: pageNum,
        catDocSTateTag: this.stateTag
        })
      this.docViewer.goToNewPageOnDetailsOpen(pageNum, false);
    })
    this.catService.showAnnotationForPhrase$.pipe(takeUntil(this.destroy$)).subscribe((element: IndElement) => {

        element.viewSw = true;
        this.onToggleElementView(element, false);
      
      })
    this.catService.focusAnnotationForElement$.pipe(takeUntil(this.destroy$)).subscribe((element: IndElement) => {
      requestAnimationFrame(() => this.docViewer?.focusAnnotation(element));
    })
    this.catService.hideAnnotationForPhrase$.pipe(takeUntil(this.destroy$)).subscribe((element: IndElement) => {

          let hideAnnotation = this.docViewer.displayAnnotations;
          if (element instanceof IndImage) {
            
            hideAnnotation = this.docViewer.displayImageAnnotations;
          }
          if (!hideAnnotation) {
            
            element.viewSw = false;
            this.onToggleElementView(element, false);
          }
      
    })
    if (this.doc.isProcessRunning) {
      this.handleProcessingDoc();
    }
  }

  ngOnDestroy(): void {
    this.reevalJobService.setDocViewOpen('CAT', false);
    if (this.scrollSyncFrameId != null) {
      cancelAnimationFrame(this.scrollSyncFrameId);
    }

    if (this.docProcessingTimer) { 
      clearInterval(this.docProcessingTimer); 

    }

    this.ngRedux.dispatch({
        type: actionsList.GET_IMAGE_CATEGORIES_FOR_DOC,
        data: []
    });
    this.currLoadedIndPhrasesSearchResultNum = 0;

    if (this.un) this.un();
    this.sub?.unsubscribe();
    if (this.processStatusTimer)
      clearInterval(this.processStatusTimer);
    if (this.handleProcessingDocTimer) {
      clearInterval(this.handleProcessingDocTimer);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  getDocObjects() {
    if (this.doc != null){
          this.catService.getDocObjects(this.doc.docId, 'IND').subscribe();
    }
  }

  loadMoreItems() {

    this.loadingMoreItems = true;
    this.filterPhrases(true);

    }
  
  loadedMoreItems() {

    this.loadingMoreItems = false;

  }

  getDocCards() {
    if (!this.doc) return;

    let sp = new CardSearchParams();
    sp.docId = this.doc.docId;
    sp.catVersionId =
      this.stateTag == CatDocStateTagEnum.SEC ? this.extCatVersionId : null;
    this.catService.getCards(sp).subscribe((data) => {
      let cards = [];
      if (this.lcSw) {
        cards = data.filter((c) => c.type.id == 'LC');
      } else {
        cards = data.filter((c) => c.type.id != 'LC');
      }

      this.ngRedux.dispatch({
        type: actionsList.GET_CAT_DOC_CARDS,
        data: cards,
        catDocSTateTag: this.stateTag,
      });

      this.catDocCardsCmp.initTabs();

      let bbKeys = [];
      cards.forEach((c) =>
        c.cardDocs.forEach((d) =>
          d.boundingBoxes.forEach((bb) => bbKeys.push(bb.s3Key))
        )
      );
      this.catService.getS3Objects(bbKeys).subscribe();
    });
  }

  drawStatusChart() {
    this.canvasStatus = document.getElementById('chart-status-cnv');
    if (!this.canvasStatus) return;

    this.ctxStatus = this.canvasStatus.getContext('2d');

    let doneCnt = this.doc.approvedCnt + this.doc.rejectedCnt + this.doc.approvedVariantCnt;
    let pendingCnt = this.doc.pendingCnt;

    let myChart = new Chart(this.ctxStatus, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [doneCnt, pendingCnt],
            backgroundColor: ['#62bd60', '#f9c74f'],
            hoverBackgroundColor: ['#62bd60', '#f9c74f'],
          },
        ],
        labels: ['Done', 'Pending'],
      },
      options: {
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems, data) => {
              return (
                data.labels[tooltipItems.index] +
                ' ' +
                data.datasets[0].data[tooltipItems.index]
              );
            },
          },
        },
        cutoutPercentage: 70,
        legend: {
          display: false,
        },
        elements: {
          center: {
            text: Math.round(this.doc.progressPct * 100) + '%',
            color: '#0978A2',
            sidePadding: 40,
          },
        },
      },
    });
  }

  goBack() {
    this.ngRedux.dispatch({
      type: actionsList.CLOSE_CAT_DOC,
      catDocSTateTag: this.stateTag,
    });

    if (this.stateTag == CatDocStateTagEnum.PRIME) {
      this.location.back();
    } else {
      this.onGoBack.emit();
    }
    //this.router.navigate([this.sharedService.routeEnum.URL_CATALOG_DOCS]);
  }

  onFilterKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.filterPhrases();
    }
  }

  resetFilterParams() {

    this.activeFilters = false;
    this.filterPhrase = null;
    this.filterSubTypes = null;
    this.filterMatchStatus = null;
    this.filterPhraseStatus = null;
    this.filterContentType = null;
    this.filterMatchType = null;
    this.filterSubTypes = null;
    this.selectedTypeNodes = null;
    if (this.stateTag == CatDocStateTagEnum.PRIME) {
      this.ngRedux.getState().curCatDocStatePrime.catPhrasesSearchParams =
        this.getSearchParams();
    } else {
      this.ngRedux.getState().curCatDocStateSec.catPhrasesSearchParams =
        this.getSearchParams();
    }
    // clear filter annotations
    if (this.docViewer) {
    
    this.docViewer.clearAnnotations();
    this.docViewer.removeBoundingBoxes();
    }
  }

  clearFilter() {
    this.resetFilterParams();

    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
      data: this.curPage,
      catDocSTateTag: this.stateTag,
    });
  }

  getSearchParams(): IndPhraseSearchParams {
    let params = new IndPhraseSearchParams();
    params.phrase = this.filterPhrase;
    params.matchStatus = this.filterMatchStatus;
    params.phraseStatus = this.filterPhraseStatus;
    params.contentType = this.filterContentType;
    params.matchType = this.filterMatchType;
    params.subTypeList = this.filterSubTypes;
    return params;
  }

  hasResults(): boolean {  
    
      return this.currLoadedIndPhrasesSearchResultNum < this.totalIndPhrasesResults;
  }

  filterPhrases(addData = false) {
    this.activeFilters = true;
    // set next search params
    let searchParams = this.getSearchParams();
    // clear annotations when start filtering
    this.docViewer.clearAnnotations();
    this.docViewer.removeBoundingBoxes();


    if (!addData) {
      
      this.currLoadedIndPhrasesSearchResultNum = 0;
      this.ngRedux.getState().totalIndPhrasesResults = 0;
    }
    // when filter is changed, numbers need to be reset

    if (this.currLoadedIndPhrasesSearchResultNum < this.totalIndPhrasesResults || this.totalIndPhrasesResults == 0) {
        
        searchParams.currLoadedIndPhraseSearchResultNum = this.currLoadedIndPhrasesSearchResultNum;
        //this.currLoadedIndPhraseSearchResultNum += 10;
         
    }
    this.addToStore = addData;
    this.ngRedux.dispatch({
      type: actionsList.FILTER_CAT_DOC_PHRASES,
      data: searchParams,
      catDocSTateTag: this.stateTag,
    });
  }

  onAddToCatalog() {
    if (this.addToCatalogDisabled) {
      return;
    }
    if (this.extSw) {
      this.loading = true;
      this.updateBulkStatus([], CatPhraseStatusEnum.APPROVE, true, true);
    } else {
      if (newCatSystemVersion(this.ngRedux.getState().curCat?.systemVersion)) {
        let validationStr = this.translateService.instant(
          'translate.cat.addDocToCatalogValidation'
        );

        this.sharedService.emitPopupchReceivedEvent({
          title: 'translate.validation.addToLibrary',
          icon: 'exclamation-triangle',
          subTitle: validationStr,
          keep: false,
          approve: () => {
            this.addToCatalog();
          },
        });
      } else {
        this.addToCatalog();
      }
    }
  }

  addToCatalog( ) {
    this.loading = true;
    let asset_type = this.doc.assetType.label;

    this.integrationService.addDocumentToLibrary(this.doc.catVersionId, this.doc.docId, asset_type).subscribe(
      (data) => {
        this.catService.processAddDocToLibraryResponse(data);
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  detach() {
    if (this.doc.attachedCardSw) {
      let validationStr = this.translateService.instant(
        'translate.cat.detachWithCardWarning'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.updateDocStatusDetached();
        },
      });
    } else {
      this.updateDocStatusDetached();
    }
  }

  reopen() {
    this.loading = true;
    this.integrationService.reopenLibraryDocument(this.doc.catVersionId, this.doc.docId).subscribe(
      (data) => {
        this.catService.processUpdIndDocResponse(data);
        this.drawStatusChart();
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  inactivateDoc() {
    this.updateDocStatus(CatDocStatusEnum.INACTIVE);
  }

  updateDocStatus(statusCode: string) {
    this.loading = true;
    this.catService.updIndDoc(this.doc, statusCode).subscribe(
      (data) => {
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  updateDocStatusDetached() {
    this.loading = true;
    let asset_type = this.doc.assetType.label;
    this.integrationService.removeDocumentFromLibrary(this.doc.catVersionId, this.doc.docId, asset_type).subscribe(
      (data) => {
        this.catService.processUpdIndDocResponse(data);
        this.drawStatusChart();
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  onTypesPanelHide() {
    if (!this.selectedTypeNodes || this.selectedTypeNodes.length == 0) {
      this.filterSubTypes = null;
    } else {
      this.filterSubTypes = this.selectedTypeNodes
        .filter((n) => n.data['treeLevel'] == 1)
        .map((n) => n.key);
    }

    let prevSearchValues =
      this.ngRedux.getState().curCatDocStatePrime.catPhrasesSearchParams == null
        ? []
        : this.ngRedux.getState().curCatDocStatePrime.catPhrasesSearchParams
            .subTypeList ?? [];
    let curSearchValues = this.filterSubTypes ?? [];
    if (curSearchValues.join(',') !== prevSearchValues.join(','))
      this.filterPhrases();
  }

  onFieldValueChanged(e: any) {
    (e.originalEvent as MouseEvent).stopPropagation();
    this.filterPhrases();
  }

  approveAllPages() {
    this.loading = true;
    this.integrationService.approveAll(this.doc.catVersionId, this.doc.docId).subscribe(
      (data) => {
        const updatedElements = this.catService.processUpdIndPhraseStatusResponse(data);
        const elements = [...this.displayedPhrases, ...this.displayedImages];
        elements.forEach((r) => {
          const updPhrase = updatedElements.find((d) => d.elementId == r.elementId);
          if (updPhrase) {
            r.statusCode = updPhrase.statusCode;
            r.statusDescr = updPhrase.statusDescr;
            r.userStatus = this.sharedService
              .getCatPhraseUpdStatusOptions()
              .find((s) => s.id == r.statusCode);
            this.onToggleElementView(r);
          }
          this.updateElements(r.imageChildren, updatedElements);
          this.updateElements(r.contentChildren, updatedElements);
          r.children && Object.keys(r.children).forEach(key => {
            this.updateElements(r.children[key], updatedElements);
          });
        });
        elements.forEach((r) => {
          r.checkedSw = false;
        });
        this.toggleAllSw = false;
        this.ngRedux.dispatch({type: actionsList.INVALIDATE_PDF_CACHE});
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  approveSelected() {
    this.updateBulkStatus(this.selectedElements, CatPhraseStatusEnum.APPROVE);
  }

  rejectSelected() {
    this.updateBulkStatus(this.selectedElements, CatPhraseStatusEnum.REJECT);
  }

  updateBulkStatus(
    elements: IndElement[],
    status: CatPhraseStatusEnum,
    allDoc: boolean = false,
    autoAddToCat: boolean = false
  ) {
    this.loading = true;
    let pageNum = this.curPage;
    if (this.activeFilters) {
      
      pageNum = null;
    }
    this.catService
      .updIndPhraseStatus(this.doc, elements, status, allDoc, pageNum)
      .subscribe(
        (data) => {
          
          if (allDoc) {
            // invalidate pdf cache to reflect changes, when approve all and add to catalog
            this.ngRedux.dispatch({type: actionsList.INVALIDATE_PDF_CACHE});
          }  
          elements.forEach((r) => {

            let updPhrase = data.find((d) => d.elementId == r.elementId);
            if (updPhrase) {
              r.statusCode = updPhrase.statusCode;
              r.statusDescr = updPhrase.statusDescr;
              r.userStatus = this.sharedService
                .getCatPhraseUpdStatusOptions()
                .find((s) => s.id == r.statusCode);
              this.onToggleElementView(r);
              } 
              this.updateElements(r.imageChildren, data);
              this.updateElements(r.contentChildren, data);
              //this.updateElements(r., data);
              r.children && Object.keys(r.children).forEach(key => {
                this.updateElements(r.children[key], data);
              });
            
          });

          elements.forEach((r) => {
            r.checkedSw = false;
          });
          this.toggleAllSw = false;
          this.loading = false;

          if (autoAddToCat) {
            this.addToCatalog();
          }
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  private updateElements(elements: IndElement[], updatedElements: IndElement[]) {

    let toUpdate: IndElement[] = [];
    elements?.forEach((r) => {

      let updPhrase = updatedElements?.find((d) => d.elementId == r.elementId);
      if (updPhrase) {
        r.statusCode = updPhrase.statusCode;
        r.statusDescr = updPhrase.statusDescr;
        r.userStatus = this.sharedService
          .getCatPhraseUpdStatusOptions()
          .find((s) => s.id == r.statusCode);
        this.onToggleElementView(r);
        toUpdate.push(r);
      }
    });
    toUpdate.forEach((r) => {

      r.checkedSw = false;
    });
  }

  addPhrase() {
    let newPhrase = new IndPhrase();
    newPhrase.docId = this.doc.docId;
    newPhrase.catId = this.curCat.catId;
    newPhrase.mergeOptions =
      this.ngRedux.getState().curCatDocStatePrime.catDocPageLines;
    newPhrase.mergeOptions.map((m) => (m.inUseSw = false));
    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_ELEMENT,
      data: newPhrase,
    });
    this.phraseDetailsOpenSw = true;
  }

  onPhraseSave() {
    this.phraseDetailsOpenSw = false;
    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
      data: this.curPage,
      catDocSTateTag: this.stateTag,
    });

    //this.createAnnotateHtmlReq();
  }

  onPageChanged(pageNum: number) {
    if (!this.activeFilters) {
      this.resetFilterParams();

      this.ngRedux.dispatch({
        type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
        data: pageNum,
        catDocSTateTag: this.stateTag,
      });
    }

    if (this.curPage !== pageNum) {
      this.ngRedux.dispatch({
        type: actionsList.SELECT_CAT_DOC_PAGE_FROM_SEARCH,
        data: pageNum,
        catDocSTateTag: this.stateTag,
      });
    }
    this.toggleAllSw = false;
  }

  onPdfScroll(): void {
    if (!this.positionSyncEnabled || this.scrollSyncFrameId != null) {
      return;
    }

    this.scrollSyncFrameId = requestAnimationFrame(() => {
      this.scrollSyncFrameId = null;
      if (!this.positionSyncEnabled || this.docViewer?.programmaticScrollActive) {
        return;
      }

      const viewer = this.docViewer?.pdfViewer?.PDFViewerApplication?.pdfViewer;
      if (!viewer) {
        return;
      }

      const elements: IndElement[] = this.sortImagesInPositionSync
        ? [...this.displayedPhrases, ...this.displayedImages]
        : [...this.displayedPhrases];
      const { pageNum, element } = this.documentPositionSyncService
        .findClosestElement(viewer, elements);
      if (!pageNum) {
        return;
      }

      const focusedElementChanged = !!element &&
        element.elementId !== this.lastScrollFocusedElementId &&
        this.phraseList?.scrollToElement(element);
      if (focusedElementChanged) {
        this.lastScrollFocusedElementId = element.elementId;
      }

      const hasHigherPageElements = elements.some(item => item.pageNum > pageNum);
      if (
        this.activeFilters &&
        !this.loadingMoreItems &&
        this.hasResults() &&
        !hasHigherPageElements
      ) {
        this.loadMoreItems();
      }
    });
  }

  onToggleAnnotations(viewSw: boolean) {
    let elements: IndElement[] = [
      ...this.displayedPhrases,
      // ...this.displayedImages,
    ];
    elements.forEach((r) => {
      if (r.pageNum == this.curPage) {
        r.viewSw = viewSw;
        this.onToggleElementView(r);
        this.toggleChildrenAnnotations(r, viewSw);
      }
    });
  }

  toggleChildrenAnnotations(element: IndElement, viewSw: boolean) {
    
    let contentChildren: IndElement[] = element.contentChildren;
    
    for(let i=0; i<contentChildren.length; i++) {
      
      let child = contentChildren[i];
      child.viewSw = viewSw;

      this.onToggleElementView(child);
    }
    //this.toggleChildrenImageAnnotation(element, viewSw);

    let childrenKeys: string[] = Object.keys(element.children);
    childrenKeys?.forEach(key => {

      let currChildArr: IndElement[] = element.children[key];
      for (let i=0; i<currChildArr.length; i++) {

        let child = currChildArr[i];
        child.viewSw = viewSw;

        this.onToggleElementView(child);
      }
    })
  }
  toggleChildrenImageAnnotation(element: IndElement, viewSw: boolean) {
    
    let imageChildren: IndElement[] = element.imageChildren;
    for (let i=0; i<imageChildren.length; i++) {

      let image = imageChildren[i];
      image.viewSw = viewSw;

      this.onToggleElementView(image);
    }
  }
  onToggleImageAnnotations(viewSw: boolean) {
    this.toggleImageAnnotationsSw = viewSw;
    let elements: IndElement[] = [
      //...this.displayedPhrases,
      ...this.displayedImages,
    ];
    elements.forEach((r) => {
      if (r.pageNum == this.curPage) {
        r.viewSw = viewSw;
        this.onToggleElementView(r);
      }
    });
    this.displayedPhrases.forEach((r) => {
      if (r.pageNum == this.curPage) {

        // toggle only images
        this.toggleChildrenImageAnnotation(r, viewSw);
      }
    })
  }

  onToggleElementView(element: IndElement, changePageSw: boolean = true) {
    let toggleElements = () => {
        
      this.hideAnnotation(element);
      
      if (element.viewSw) {
        this.showAnnotation(element);
      } 
    };

    if (element.pageNum !== this.curPage && changePageSw) {
      this.ngRedux.dispatch({
        type: actionsList.SELECT_CAT_DOC_PAGE_FROM_SEARCH,
        data: element.pageNum,
        catDocSTateTag: CatDocStateTagEnum.PRIME,
      });
      this.docViewer.goToPage(element.pageNum);
    } else {
      toggleElements();
    }
  }

  hideAnnotation(element: IndElement) {
    element.annId = element.elementId;
    this.docViewer.hideAnnotation(element, false);
  }

  showAnnotation(element: IndElement, visible: boolean = true) {
    if (element.bgImgSw || element.pageNum != this.docViewer.displayedPage)
      return;

    switch (element.statusCode) {
      case CatPhraseStatusEnum.APPROVE:
        element.annColor = '#62bd60';
        break;
      case CatPhraseStatusEnum.APPROVE_VAR:
        element.annColor = '#62bd60';
        break;
      case CatPhraseStatusEnum.REJECT:
        element.annColor = '#f35f3e';
        break;
      case CatPhraseStatusEnum.PENDING:
        element.annColor = '#f9c74f';
        break;
      default:
        element.annColor = '#0978A2';
        break;
    }
    element.annId = element.elementId;
    this.docViewer.showAnnotation(element, visible);
  }

  onDocIframeLoaded() {
    this.docFrameLoadedPageNum = this.curPage;

    /*
    if (
      //this.initAnnotationsloadedPageNum !== this.curPage &&
      this.phraseListLoadedPageNum == this.curPage
    ) {
      this.addAllAnnotationsToDoc();
      if (this.lcSw) return;

      setTimeout(() => {
        this.togglePendingAnnotations();
      }, 500);
    }
    */
    this.docFrameLoaded = true;
    this.catService.pdfPageLoaded$.next(true);
    if (this.activeFilters) {
      this.catService.searchFinished$.next(true);
    }
  }
    onNewPageLoaded() {
    this.docFrameLoadedPageNum = this.curPage;
    console.log('frame loaded: ' + this.docFrameLoadedPageNum);


    this.docFrameLoaded = true;
    this.catService.pdfPageLoaded$.next(true);
    if (this.activeFilters) {
      this.catService.searchFinished$.next(true);
    }
    this.catService.pdfAnnotationRenderReady$.next();
  }

  addAllAnnotationsToDoc() {
    let elements: IndElement[] = [
      ...this.displayedPhrases,
      ...this.displayedImages,
    ];
    elements.forEach((r) => {
      this.showAnnotation(r, false);
    });
  }

  togglePendingAnnotations() {
    let elements: IndElement[] = [
      ...this.displayedPhrases,
      //...this.displayedImages,
    ];
    this.initAnnotationsloadedPageNum = this.curPage;
    elements.forEach((r) => {
      r.viewSw = r.statusCode == CatPhraseStatusEnum.PENDING;
      this.onToggleElementView(r, false);
    });
  }

  onToggleSelectAll() {
    //this.displayedPhrases.forEach((p) => (p.checkedSw = this.toggleAllSw));

    this.displayedPhrases.forEach((phrase) => {
      
      phrase.checkedSw = this.toggleAllSw;
      let contentChildren: IndElement[] = phrase.contentChildren;
      contentChildren?.forEach((child) => {
        if (child instanceof IndPhrase) {

          child.checkedSw = this.toggleAllSw;
        }
      })
      let children = phrase.children;
      children && Object.keys(children).forEach((key) => {
        children[key]?.forEach((child) => {
          if (child instanceof IndPhrase) {
            child.checkedSw = this.toggleAllSw;
          }
        })
      })
    })
  }

  onToggleSelectAllImg() {
    this.displayedImages.forEach((p) => (p.checkedSw = this.toggleAllImgSw));

    this.displayedPhrases.forEach((phrase) => {

      let imageChildren: IndElement[] = phrase.imageChildren;
      imageChildren.forEach((child) => {
          child.checkedSw = this.toggleAllImgSw;
      })

    })
  }

  onBoundingBoxDraw(box: BoundingBox) {
    this.curBoundingBox = box;
    this.boundingBoxOpenSw = true;
  }

  onBoundingBoxDiscard() {
    this.docViewer.removeBoundingBoxes();
    this.boundingBoxOpenSw = false;
  }

  onBoundingBoxSave(box: BoundingBox) {
    this.docViewer.removeBoundingBoxes();
    this.boundingBoxOpenSw = false;
    let ob = this.catService.createBoundingBoxImage(box);

    ob.subscribe({
      next: () => {
        this.getDocCards();
        if (this.lcSw)
          this.ngRedux.dispatch({
            type: actionsList.RELOAD_CUR_LC_REQ,
          });
      },
    });

    this.getDocCards();
    
    // should consider filters not delete them
    if (this.activeFilters) {
        
      this.resetFilterParams(); 
    }
    
      this.ngRedux.dispatch({
        type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
        data: this.curPage,
        catDocSTateTag: this.stateTag,
      });
  

    if (this.lcSw)
      this.ngRedux.dispatch({
        type: actionsList.RELOAD_CUR_LC_REQ,
        data: ob,
      });
  }

  onImageSave(imageId: number) {
    this.docViewer.removeBoundingBoxes();
    this.boundingBoxOpenSw = false;
    this.catService.createIndImage(this.doc.docId, imageId).subscribe({
      next: (imgUrl) => {
        this.resetFilterParams();
        this.ngRedux.dispatch({
          type: actionsList.SELECT_CAT_DOC_PAGE_NUM,
          data: this.curPage,
          catDocSTateTag: this.stateTag,
        });
        this.getDocObjects();
      },
    });
  }

  onBoundingBoxDelete() {
    this.docViewer.removeBoundingBox(this.curBoundingBox);
    this.boundingBoxOpenSw = false;
    this.getDocCards();
  }

  onToggleBoundingBoxes(viewSw: boolean) {
    this.catDocBoundingBoxes.forEach((b) => {

        this.docViewer.removeBoundingBox(b);
      
      if (viewSw) {
        this.docViewer.displayBoundingBox(b);
      }
    });
  }

  onBoundingBoxClicked(elementId: String) {
    this.curBoundingBox = this.catDocBoundingBoxes.find(
      (b) => b.elementId == elementId
    );
    if (this.curBoundingBox) {
      // this.boundingBoxOpenSw = true;
      this.docCardsOpenSw = true;
    }
  }

  onAnnMouseEnter(ann: AnnotationElement) {
    let element: IndElement;
    if (ann.annIdPrefix == 'img') {
      // if (!this.toggleImageAnnotationsSw) {
      //   return;
      // }
      element = this.ngRedux
        .getState()
        .curCatDocStatePrime.indDocImages.find((r) => r.elementId == ann.annId);
    } else {
      element = this.ngRedux
        .getState()
        .curCatDocStatePrime.indDocPhrases.find(
          (r) => r.elementId == ann.annId
        );
    }

    if (element) this.phraseList.onMouseEnter(element);
  }

  onAnnMouseLeave(ann: AnnotationElement) {
    let element: IndElement;
    if (ann.annIdPrefix == 'img') {
      element = this.ngRedux
        .getState()
        .curCatDocStatePrime.indDocImages.find((r) => r.elementId == ann.annId);
    } else {
      element = this.ngRedux
        .getState()
        .curCatDocStatePrime.indDocPhrases.find(
          (r) => r.elementId == ann.annId
        );
    }

    if (element) this.phraseList.onMouseLeave(element);
  }
  findImageChildren(element: IndElement, annId: number): IndElement | null {
    
    let imageChildren: IndElement[] = element.imageChildren as IndElement[];
    for (let i = 0; i < imageChildren?.length; i++) {

      let child = imageChildren[i];
      if (child.elementId == annId) {
          return child;
      }
    }
    return null;
  }
  
  findImage(ann: AnnotationElement): IndElement {
    for (let i=0; i<this.displayedImages?.length; i++) {
      let image = this.displayedImages[i];
      if (image.elementId == ann.annId) {
        return image; 
      }
    }

    for (let i=0; i<this.displayedPhrases?.length; i++) {
      let phrase = this.displayedPhrases[i];
      let foundImageChildren = this.findImageChildren(phrase, ann.annId);
      if (foundImageChildren) {
        return foundImageChildren;
      }
    }

    return null;
  }

  findPhraseContentChildren(element: IndElement, annId: number): IndElement | null {

    let phraseChildren: IndElement[] = element.contentChildren as IndElement[];
    for (let i = 0; i < phraseChildren?.length; i++) {
      let child = phraseChildren[i];
      if (child.elementId == annId) {
          return child;
      }
    }
    return null;
  }
  findPhraseChildren(element: IndElement, annId: number): IndElement | null {
  
    let childrenKeys: string[] = Object.keys(element.children);

    for (let i=0; i<childrenKeys?.length; i++) {
      let key = childrenKeys[i];
      let currChildArr: IndElement[] = element.children[key];
      for (let i = 0; i < currChildArr.length; i++) {
        let child = currChildArr[i];
        if (child.elementId == annId) {
            return child;
            
        }
      }
    }
    return null;
  }
  findPhrase(ann: AnnotationElement): IndElement {
    for (let i=0; i<this.displayedPhrases?.length; i++) {
      let phrase = this.displayedPhrases[i];
      if (phrase.elementId == ann.annId) {
        return phrase;
      }
      let foundPhraseChildren = this.findPhraseChildren(phrase, ann.annId);
      if (foundPhraseChildren) {
        return foundPhraseChildren;
      }
       foundPhraseChildren = this.findImageChildren(phrase, ann.annId);
      if (foundPhraseChildren) {
        return foundPhraseChildren;
      }
      foundPhraseChildren = this.findPhraseContentChildren(phrase, ann.annId);
      if (foundPhraseChildren) {
        return foundPhraseChildren;
      }
    }
    return null;
  }


  onAnnClicked(ann: AnnotationElement) {
    let element: IndElement;

    if (ann instanceof IndImage) {
      element = this.findImage(ann);
    }

    if (ann instanceof IndPhrase) {
      element = this.findPhrase(ann);
    }
    
    if (element) {
      this.ngRedux.dispatch({
        type: actionsList.CAT_PHRASE_ANN_CLICKED,
        data: element,
      });
    }
  }

  editSelected() {
    this.editPhraseTypeOpenSw = true;
  }

  onBulkEditSave(phraseType: TreeNode) {
    this.catService
      .updBulkIndDocPhrase(
        this.selectedPhrases,
        phraseType.parent.data.typeCode,
        phraseType.data.typeCode
      )
      .subscribe(
        (data) => {
          this.selectedPhrases.forEach((p) => {
            p.typeCode = phraseType.parent.data.typeCode;
            p.typeDescr = phraseType.parent.data.typeDescr;
            p.subTypeCode = phraseType.data.typeCode;
            p.subTypeDescr = phraseType.data.typeDescr;
          });
          this.selectedPhrases.forEach((p) => {
            p.checkedSw = false;
          });
          this.phraseBulkEditCmp.loading = false;
          this.editPhraseTypeOpenSw = false;
        },
        (err) => {
          this.phraseBulkEditCmp.loading = false;
        }
      );
  }

  onPanelResizeStart(event: any) {
    this.panelResizing = true;
  }

  onPanelResizeEnd(event: any) {
    this.panelResizing = false;
  }

  addExtRef() {
    //this.onAddExtRef.emit(this.selectedPhrases);
    this.addExtRefLoading = true;
    let cnt = 0;

    this.selectedPhrases.forEach((phrase) => {
      let extRef = new ExtRef();
      extRef.srcDocId =
        this.ngRedux.getState().curCatDocStatePrime.curCatDoc.docId;
      extRef.type = 'PHRASE';
      extRef.srcPhraseId = this.srcPhraseId;
      extRef.extDocId = this.doc.docId;
      extRef.extCatVersionId = this.extCatVersionId;
      extRef.extType = 'PHRASE';
      extRef.extPhraseId = phrase.phraseId;

      this.catService.updExtRefPointer(extRef).subscribe(
        (data) => {
          cnt++;
          if (cnt == this.selectedPhrases.length) this.onAddExtRef.emit();
        },
        (err) => {
          this.addExtRefLoading = false;
        }
      );
    });
  }

  postPhraseOrderEdit() {
    this.editPhraseOrderOpenSw = false;
    this.ngRedux.dispatch({
      type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
      data: true,
    });
  }

  downloadIndd() {
    this.downloadingZip = true;
    this.catService.getS3Objects([this.doc.inddS3Key]).subscribe(
      () => {        
        let url = this.catService.getS3TempObjectPresignedUrl(this.doc.inddS3Key);
        this.tryDownloadFile(url);
      },
      (err) => {
        this.downloadingZip = false;
      }
    );
  }

  tryDownloadFile(url: string) {
    this.sub?.unsubscribe();
    this.sub = this.catService.checkFileExists(url).subscribe(
      (exists) => {
        if (exists) {
          console.log(url);
          var element = document.createElement('a');
          element.href = url;
          element.setAttribute('download', this.doc.fileName);
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          this.downloadingZip = false;
        } else {
          setTimeout(() => {
            this.tryDownloadFile(url);
          }, 100);
        }
      },
      (err) => {
        this.downloadingZip = false;
      }
    );
  }
  onUpdateSpellingWhitelist() {
    this.docSpellcheckWhitelistingOpenSw = false;
    this.ngOnInit();
  }

  handleProcessingDoc() {
    this.handleProcessingDocTimer = setInterval(() => {
      
      this.authService.getProcessStatus(this.doc.runNum).subscribe(
        (data) => {
          this.doc.processStatus = data;
          this.doc.runStatusCode = data.status as string;
          if (
            data.status == ProcessRunStatusEnum.FINISHED ||
            data.status == ProcessRunStatusEnum.FAILED
          ) {
            this.displayProcessStatus = false;
          }
        },
        (err) => {
          this.getProcStatusFailedCnt++;
          if (this.getProcStatusFailedCnt > 20) {
            clearInterval(this.handleProcessingDocTimer);
          }
        }
      );
    }, this.getProcessStatusIntervalSeconds * 1000);
  }

  openProcessStatus(doc: CatDoc, event: Event) {
    event.stopPropagation();  
    this.displayProcessStatus = true;
  }

  checkProcessStatusAndOpen(revDoc: CatDoc, event: Event) {

    if (revDoc.processStatus) {
      this.openProcessStatus(revDoc, event);
    }
  }
  get lang() {
    return this.ngRedux.getState().ui_lang
  }



}
